import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteIapPollResponseBody } from '../IapPollsApi.types';
import { useApi } from '~/lib/api/useApi';
import { iapPollQueryKeyFactory } from './useIapPollQuery';
import { iapPollsQueryKeyFactory } from './useIapPollsQuery';

export type IUseDeleteIapPollMutationValues = {
  appId: string;
  iapPollId: string;
};

export const useDeleteIapPollMutation = (): UseMutationResult<
  IApiDeleteIapPollResponseBody,
  unknown,
  IUseDeleteIapPollMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteIapPollMutationValues) =>
      api.iapPolls.delete(values.appId, values.iapPollId),
    onSuccess: async (_, values) => {
      [
        // TODO once the API is updated to return the deleted resources
        // data.deletedResources.pollIds
        values.iapPollId,
      ]
        .map((streamId) => [
          {
            queryKey: iapPollQueryKeyFactory({
              appId: values.appId,
              iapPollId: streamId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: iapPollsQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
